interface PriceProps {
  amount: number | string | undefined;
  currencyCode: string;
  className?: string;
}

export const Price: React.FC<PriceProps> = ({
  amount,
  currencyCode,
  className,
}: PriceProps) => {
  const formatPrice = (amount: number | bigint, currencyCode: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
    }).format(amount);
  };

  return (
    <span className={className}>
      {formatPrice(Number(amount || 0), currencyCode)}
    </span>
  );
};

export default Price;
